import Typed from "typed.js";

const PageIntro = () => {
	const block = document.querySelectorAll(".page-intro");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const subtitle = el.querySelector(".page-intro__subtitle");
		const subtitleWords = subtitle && subtitle.getAttribute("data-words");

		const title = el.querySelector(".page-intro__title");
		const titleWords = title && title.getAttribute("data-words");

		// breadcrumbs fix position
		const body = el.querySelector(".page-intro__body");
		const breadcrumbsGlobal = document.querySelector(".breadcrumbs__global");
		if (breadcrumbsGlobal && body) {
			body.prepend(breadcrumbsGlobal);
		}

		if (subtitle && subtitleWords) {
			const typed = new Typed(subtitle.querySelector("span"), {
				strings: subtitleWords.split(","),
				startDelay: 300,
				typeSpeed: 100,
				backSpeed: 50,
				backDelay: 1000,
				loop: true,
				showCursor: false
			});
		}

		if (title && titleWords) {
			const typed = new Typed(title.querySelector("span"), {
				strings: titleWords.split(","),
				startDelay: 300,
				typeSpeed: 100,
				backSpeed: 50,
				backDelay: 3000,
				loop: true,
				showCursor: false
			});
		}
	});
};

export default PageIntro;
